import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text } from 'components/ui';
import EN from 'components/Header/locales/Header_en_US.js';
import FR from 'components/Header/locales/Header_fr_CA.js';
import LanguageLocale from 'utils/LanguageLocale';
import addressUtils from 'utils/Address';
import preferredStoreInfoSelector from 'selectors/user/preferredStoreInfoSelector';
import PreferredZipCodeSelector from 'selectors/user/preferredZipCodeSelector';

const { getLocalisedDataFromResource } = LanguageLocale;
const { preferredZipCodeSelector } = PreferredZipCodeSelector;
const getText = getLocalisedDataFromResource(EN, FR);

function getStoreNameAndZipCode(storeName, zipCode) {
    if (storeName && zipCode) {
        return `${storeName} • ${zipCode}`;
    }

    if (storeName) {
        return `${storeName} • ${getText('chooseYourLocation')}`;
    }

    if (zipCode) {
        return `${getText('chooseYourStore')} • ${zipCode}`;
    }

    return getText('chooseYourStoreAndLocation');
}

function PreferredStoreAndZipCode({ hasSephora: _hasSephora, ...restProps }) {
    const preferredStoreInfo = useSelector(preferredStoreInfoSelector);
    const preferredZipCode = useSelector(preferredZipCodeSelector);
    const [isHydrated, setIsHydrated] = useState(false);

    useEffect(() => {
        setIsHydrated(true);
    }, []);

    const storeNameAndZipCode = isHydrated
        ? getStoreNameAndZipCode(preferredStoreInfo.displayName, addressUtils.formatZipCode(preferredZipCode))
        : getText('chooseYourStoreAndLocation');

    return (
        <Text
            fontSize='sm'
            display='block'
            paddingBottom={1}
            marginBottom={-1}
            {...restProps}
        >
            {storeNameAndZipCode}
        </Text>
    );
}

export default wrapFunctionalComponent(PreferredStoreAndZipCode, 'PreferredStoreAndZipCode');
